import AreaPage from "@/components/AreaPage";

const area = {
  name: "DLF Phase 1-5",
  slug: "water-tank-cleaning-dlf-phase-gurugram",
  h1: "Water Tank Cleaning in DLF Phase 1-5, Gurugram",
  description: "Professional water tank cleaning service in DLF Phase 1-5, Gurugram. Residential and commercial tanks cleaned by certified experts.",
  content1: "TankBuddy provides premium water tank cleaning services across all DLF Phases (1, 2, 3, 4, and 5) in Gurugram. DLF is home to some of Gurugram's finest residential complexes, independent floors, and luxury villas — all requiring regular tank maintenance to ensure clean drinking water for families. Our certified technicians serve DLF Cyber City offices, DLF Magnolias, DLF Aralias, DLF Belaire, and all residential sectors within DLF Phases.",
  content2: "Whether you have an overhead PVC tank on your DLF villa's rooftop or a large underground RCC tank serving your apartment complex, TankBuddy's same-day service ensures you never compromise on water hygiene. We use eco-friendly, food-grade cleaning agents and high-pressure jet equipment specifically suited for the premium homes in DLF Phases. Book today and get sparkling clean tanks within 3 hours.",
  nearby: [
    { href: "/water-tank-cleaning-golf-course-road-gurugram", label: "Golf Course Road" },
    { href: "/water-tank-cleaning-sushant-lok-gurugram", label: "Sushant Lok" },
    { href: "/water-tank-cleaning-mg-road-gurugram", label: "MG Road" },
    { href: "/water-tank-cleaning-palam-vihar-gurugram", label: "Palam Vihar" },
  ],
};

export default function DLFPhasePage() {
  return <AreaPage area={area} />;
}
